import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import GroupsIndexCard from '../../Groups/GroupsIndexCard';

export default function GroupsPage(props) {
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.groups')}
				category={I18n.t('admin.groups')}
			/>
			<GroupsIndexCard
				public_id={props.public_id}
				iam_create_group_endpoint={props.iam_create_group_endpoint}
				iam_get_group_endpoint={props.iam_get_group_endpoint}
				iam_update_group_endpoint={props.iam_update_group_endpoint}
				iam_delete_group_endpoint={props.iam_delete_group_endpoint}
				iam_get_groups_endpoint={props.iam_get_groups_endpoint}
			/>
		</div>
	);
}
